import { CurrencyFormatterPipe } from "./shared/pipe/currency-formatter.pipe";
import { AdminAuthGuard } from "./shared/guard/auth-guard-admin.service";
import { SnailTrailMapComponent } from "./snail-trail/components/snail-trail-map.component";
import { SnailTrailComponent } from "./snail-trail/components/snail-trail.component";
import { SnailTrailFilterComponent } from "./snail-trail/components/snail-trail-filter.component";
import { ColorPickerModule } from "ngx-color-picker";
import { BrandingComponent } from "./branding/components/branding.component";
// import { ActiveMenuItemDirective } from './branding/active-menu-item.directive';
// import { HighLightDirective } from './branding/highlight-panel.directive';
// import { CalendarEventDirective } from './branding/calendar-event.directive';
// import { SecondaryButtonDirective } from './branding/secondary-button.directive';
// import { HyperLinkDirective } from './branding/hyper-link.directive';
// import { PrimaryButtonDirective } from './branding/primary-button.directive';
// import { TopBarItemDirective } from "./branding/top-bar-item.directive";
import { VehicleOccupancy } from "./report/components/vehicle-occupancy.component";
import { AdminDashboardGridComponent } from "./dashboard/components/admin-dashboard-grid-component";
import { AdminDashboardFilterComponent } from "./dashboard/components/admin-dashboard-filter.component";
import { AdminDashboardComponent } from "./dashboard/components/admin-dashboard.component";
import { LanguageHelperAPIComponent } from "./shared/components/language-herlper-api.component";
import { OdometerLogTrailUpdateComponent } from "./odometerlogtrail/components/odometerlogtrail-update.component";
import { OdometerLogTrailListComponent } from "./odometerlogtrail/components/odometerlogtrail-list.component";
import { DecimalFormatterService } from "./shared/models/decimal-formatter.service";
import { DecimalFormatterPipe } from "./shared/pipe/decimal-formatter.pipe";
import { LanguageHelperComponent } from "./shared/components/language-herlper.component";
import { GeoLocationMapComponent } from "./shared/components/geo-location-map.component";
import { VTSHistoryListComponent } from "./vtshistory/components/vtshistory-list.component";
import { EventViewerComponent } from "./event-viewer/components/event-viewer.component";
import { VehicleFutureBookingListComponent } from "./vehicle/components/vehiclefuturebooking-list.component";
import { TripDetailReportComponent } from "./tripdetailreport/components/tripdetailreport.components";
import { VehicleInformationComponent } from "./vehicle/components/vehicle-information.component";
import { ReportDamagePopupComponent } from "./booking/components/report-damage-popup.component";
import { SVGDriverComponent } from "./sharedvehiclegroup/components/svgdriver-list.component";
import { BookingOverviewDriverComponent } from "./booking-driver/components/booking-overview-driver.component";
import { ConfirmBookingDriverComponent } from "./booking-driver/components/confirm-booking-driver.component";
import { VehicleOverviewDriverComponent } from "./booking-driver/components/vehicle-overview-driver.component";
import { FilterVehicleOverviewDriverComponent } from "./booking-driver/components/filter-vehicle-overview-driver.component";
import { SchedularBookingDriverComponent } from "./booking-driver/components/scheduler-booking-driver.component";
import { SearchBookingDriverComponent } from "./booking-driver/components/search-booking-driver.component";
import { BookingDriverComponent } from "./booking-driver/components/booking-driver.component";
import { DriverProfile } from "./driver/components/driver-profile.component";
import { DriverDashboardComponent } from "./dashboard/components/driver-dashboard.component";
import { PopoverModule } from "ng2-popover";
import { InboxDriverListComponent } from "./inbox/components/inbox-driver.component";
import { DriverSearchListComponent } from "./shared/components/driver-search-list.component";
import { SearchFilterComponent } from "./termsandcondition/components/search-filter.component";
import { DriverRoleComponent } from "./role/components/driver-role.component";
import { DriverNavBarComponent } from "./driver-template/component/driver-navbar.component";
import { DriverFooterComponent } from "./driver-template/component/driver-footer.component";
import { GeoLocationPopupComponent } from "./shared/popup/geolocation-popup.component";
import { PersonProfileSuccessComponent } from "./personprofile/componets/personprofilesuccess.componets";
import { PersonProfileFailurComponent } from "./personprofile/componets/personprofilefailure.componets";
import { PersonProfile } from "./personprofile/componets/personprofile.componets";
import { UnderConstructionComponent } from "./shared/components/underconstruction.component";
import { LinkExpiredComponent } from "./shared/components/link-expired.compontnet";
import { ForgotPasswordComponent } from "./forgotpassword/components/forgotpassword.component";
import { ChangePasswordSuccessComponent } from "./forgotpassword/components/changepasswordsuccess.component";
import { ChangePasswordComponent } from "./forgotpassword/components/changepassword.component";
import { GAdminComponent } from "./role/components/gadmin.component";
import { CAdminComponent } from "./role/components/cadmin.component";
// import { AssignVehicleGroupPopupComponent } from './vehicle/components/assign-vehicle-group-popup.component';
// import { VehicleSVGListComponent } from './vehicle/components/vehicle-svg-list.component';
import { InboxViewComponent } from "./inbox/components/inbox-view.component";
import { InboxListComponent } from "./inbox/components/inbox-list.component";
import { InboxComponent } from "./inbox/components/inbox.component";
import { TinymceEditorComponent } from "./plugins/tinymce/editor.component";
import { TemplateUpdateComponent } from "./template/components/template-update.component";
import { UserProfile } from "./userprofile/components/userprofile.componets";
import { ChangePasswordPopupComponent } from "./userprofile/components/changepassword-popup.component";
import { ProgressbarModule } from "ng2-bootstrap/components/progressbar";
import { AlertModule } from "ng2-bootstrap/components/alert";
import { FlatPickrDirective } from "./plugins/flatpickr/flatpickr.directive";
import { VehicleOverviewComponent } from "./booking/components/vehicle-overview.component";
import { SearchBookingComponent } from "./booking/components/search-booking.component";
import { SchedularBookingComponent } from "./booking/components/scheduler-booking.component";
import { FilterVehicleOverviewComponent } from "./booking/components/filter-vehicle-overview.component";
import { SelectDriverPopupComponent } from "./booking/components/select-driver-popup.component";
import { ConfirmBookingComponent } from "./booking/components/confirm-booking.component";
import { BookingOverviewComponent } from "./booking/components/booking-overview.component";
import { BookingRequestComponent } from "./booking/components/booking-request.component";
import { BookingHistoryComponent } from "./booking/components/booking-history.component";
import { BookingApproveComponent } from "./booking/components/booking-approve.component";
import { BookingComponent } from "./booking/components/booking.component";
import { BookingInformationComponent } from "./booking/components/booking-information.component";
import { BookingInformationComponent2 } from "./booking/components/booking-information2.component";
import { BookingInformationComponent3 } from "./booking/components/booking-information3.component";
import { DriverBookingInformationComponent } from "./driver/components/driver-bookinginformation.component";
import { SelectVehiclePopupComponent } from "./booking-special/components/select-vehicle-popup.component";
import { SpecialBookingComponent } from "./booking-special/components/special-booking.component";
import { InvoiceLegacyListComponent } from "./invoice/components/invoice-legacy-list.component";
import { InvoiceListComponent } from "./invoice/components/invoice-list.component";
import { ContractTypeHistoryComponent } from "./contractType/components/contractType-history.component";
import { ContractTypeUpdateComponent } from "./contractType/components/contractType-update.component";
import { ContractTypeListComponent } from "./contractType/components/contractType-list.component";
import { InActiveContractTypeGroupPopupComponent } from "./contracttypegroup/components/add-contracttypegroup-popup.component";
import { ContractTypeGroupUpdateComponent } from "./contracttypegroup/components/contracttypegroup-update.component";
import { ContractTypeGroupListComponent } from "./contracttypegroup/components/contracttypegroup-list.component";
import { SharedVehicleGroupUpdateComponent } from "./sharedvehiclegroup/components/sharedvehiclegroup-update.component";
import { SubscriptionUpdateComponent } from "./sharedvehiclegroupsubscription/components/sharedvehicelsubscription-update.component";
import { SubscriptionListComponent } from "./sharedvehiclegroupsubscription/components/sharedvehiclesubscription-list.component";
import { SubscriptionAvailabilityListComponent } from "./subscriptionavailabilityrestriction/components/subscriptionavailabilityrestriction-list.component";
import { SubscriptionaAvailabilityUpdateComponent } from "./subscriptionavailabilityrestriction/components/subscriptionavailabilityrestriction-update.component";
import { SVGVehicleComponent } from "./sharedvehiclegroup/components/svgvehicle-list.component";
import { AddGroupVehiclePopupComponent } from "./sharedvehiclegroup/components/add-groupvehicle-popup.component";
import { AddSharedVehicleGroupAdminPopupComponent } from "./sharedvehiclegroupadmin/components/add-sharedvehiclegroupadmin-popup.component";
import { SharedVehicleGroupAdminListComponent } from "./sharedvehiclegroupadmin/components/sharedvehiclegroupadmin-list.component";
import { DriverSubscriptionListComponent } from "./driver/components/driversubscription-list.component";
import { DriverSVGListComponent } from "./driver/components/driverSVG-list.component";
import { AssignDriverGroupPopupComponent } from "./driver/components/assign-driver-group-popup.component";
import { TemplateListComponent } from "./template/components/template-list.component";
import { AddWegoAdminPopupComponent } from "./wegoadminlist/components/add-wegoadmin-popup.component";
import { WegoAdminListComponent } from "./wegoadminlist/components/wegoadmin-list.component";
import { AddDriverPopupComponent } from "./driver/components/add-driver-popup.component";
import { SharedVehicleGroupListComponent } from "./sharedvehiclegroup/components/sharedvehiclegroup-list.component";
import { DriverListComponent } from "./driver/components/driver-list.component";
import { SpecialPeriodUpdateComponent } from "./specialperiod/components/specialperiod-update.component";
import { SpecialPeriodListComponent } from "./specialperiod/components/specialperiod-list.component";
import { VehicleAttributeUpdateComponent } from "./vehicle-attribute/components/vehicleattribute-update.component";
import { VehicleAttributeListComponent } from "./vehicle-attribute/components/vehicleattribute-list.component";
import { VehicleAttributeCategoryUpdateComponent } from "./vehicle-attribute-category/components/vehicleattributecategory-update.component";
import { VehicleAttributeCategoryListComponent } from "./vehicle-attribute-category/components/vehicleattributecategory-list.component";
import { VehicleUpdateComponent } from "./vehicle/components/vehicle-update.component";
import { VehicleListComponent } from "./vehicle/components/vehicle-list.component";
import { VtsVehicleUpdateComponent } from "./vehicle/components/vtsvehicle-update.component";
import { VtsVehicleListComponent } from "./vehicle/components/vtsvehicle-list.component";
import { AddCompanyAdminPopupComponent } from "./company-admin/components/add-companyadmin-popup.component";
import { CompanyAdminListComponent } from "./company-admin/components/companyAdmin-list.component";
import { CompanyUpdateComponent } from "./company/components/company-update.component";
import { CompanyContactPopupComponent } from "./company/components/company-contact-popup.component";
import { CompanyListComponent } from "./company/components/company-list.component";
import { PersonUpdateComponent } from "./person/components/person-update.component";
import { PersonListComponent } from "./person/components/person-list.component";
import { InstanceUpdateComponent } from "./instance/components/instance-update.component";
import { ReadMorePipe } from "./shared/pipe/read-more.pipe";
import { ServerErrorMessagePipe } from "./shared/pipe/server-error.pipe";
import { ConfirmPopupComponent } from "./shared/popup/confirm-popup.component";
import { SuccessPopupComponent } from "./shared/popup/success-popup.component";
import { DriverAdminAuthGuard } from "./shared/guard/auth-guard-driveradmin.service";
import { GAdminAuthGuard } from "./shared/guard/auth-guard-gadmin.service";
import { CAdminAuthGuard } from "./shared/guard/auth-guard-cadmin.service";
import { WAdminAuthGuard } from "./shared/guard/auth-guard-wadmin.service";
import { AuthGuard } from "./shared/guard/auth-guard.service";
import { ContentWrapperComponent } from "./admin-template/components/content-wrapper.component";
import { WegoAdminComponent } from "./role/components/wegoadmin.component";
import { InstanceListComponent } from "./instance/components/instance-list.component";
import { SearchListComponent } from "./shared/components/search-list.component";
import { SortListComponent } from "./shared/components/sort-list.component";
import { BackofficeComponent } from "./backoffice/components/backoffice.component";
import { TripHistoryComponent } from "./trip/components/trip-history.component";
import { DriverTripInformationComponent } from "./driver/components/driver-tripinformation.component";
import {
  TRANSLATION_PROVIDERS,
  TranslateService,
  TranslatePipe
} from "./shared/translate";
import { LodderComponent } from "./shared/components/lodder.component";
import { PopupLodderComponent } from "./shared/components/popup-lodder.component";
import { AuthService } from "./shared/models/auth.service";
import { NotFoundComponent } from "./shared/components/notfound.component";
import { PrivacyNotAllowComponent } from "./shared/components/privacy-not-allow.component";
import { UnAuthenticatedComponent } from "./shared/components/unauthenticated.component";
import { UnAuthorizedComponent } from "./shared/components/unauthorized.component";
import { AppRoutingModule } from "./app-routing.module";
import { LoginComponent } from "./login/components/login.component";
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { AppComponent } from "./app.component";
import {
  NavbarComponent,
  SidebarComponent,
  MenuItem,
  FooterComponent
} from "./admin-template";
import {
  DropdownModule,
  PaginationModule,
  ModalModule
} from "ng2-bootstrap/ng2-bootstrap";
import { AgmCoreModule } from "angular2-google-maps/core";
import { FileSelectDirective } from "ng2-file-upload";
import { GoogleplaceDirective } from "./plugins/googleaddressautocomplete/google-address-autocomplete";
import { ImportPersonCsvComponent } from "./import-data/components/import-person-csv.component";
import { AdditionalFreeItemsUpdateComponent } from "./additionalfreeitem/components/additionalfreeitems-update.component";
import { SelectDriverSubscriptionPopupComponent } from "./additionalfreeitem/components/select-driver-subscription-popup.component";
import { AdditionalFreeItemListComponent } from "./additionalfreeitem/components/additionalfreeitems-list.component";
import { BookingTripDetailpopupComponent } from "./booking/components/bookingtrip-detail-popup.component";
import { DriverLicenceComponent } from "./validatedriverlicence/components/driverlicencedetail.component";
import { ImagePopupComponent } from "./shared/popup/image-popup.component";
import { BookingExpensePopupComponent } from "./booking/components/booking-expense-popup.component";
import { VTSTroubleshootComponent } from "./vts-troubleshoot/components/vts-troubleshoot.component";
import { FreeBookingpopupComponent } from "./booking/components/free-booking-popup.component";
import { CalanderPopupComponent } from "./booking/components/calander-popup.component";
import { BookingInfoPopupComponent } from "./booking/components/booking-info-popup.component";
import { SignupFormConfigUpdateComponent } from "./signupform/components/signupformconfig-update.compnent";
import { SignUpComponent } from "./signup/components/signup.component";
import { SignupFormConfigListComponent } from "./signupform/components/signupformconfig-list.component";
import { SignupListComponent } from "./signupform/components/signup-list.component";
import { ConfirmSignupPopupComponent } from "./signupform/components/confirm-signup-popup.component";
import { MissingIBANPopupComponent } from "./invoice/components/missing-iban-popup.component";
import { DirectDebitFileListComponent } from "./invoice/components/directdebit-file-list.component";
import { BatchUploadPersonComponent } from "./batchuploadperson/component/batch-upload-person.component";
import { CreateDirectDebitFilePopupComponent } from "./invoice/components/create-directdebit-file-popup.component";
import { DirectdebitCollectionDatePopupComponent } from "./invoice/components/directdebit-collection-date-popup.component";
import { AssignToSVGComponent } from "./batchuploadperson/component/assign-to-svg-popup.component";
import { ReportFilter } from "./report/components/report-filter.component";
import { MaintenancePlanningReportComponent } from "./report/components/maintenance-planning.component";
import { RevenuepervehicleReportComponent } from "./report/components/revenue-per-vehicle.component";
import { TripDataReportComponent } from "./tripdatareport/components/tripdatareport.component";
import { OrganizationUpdateComponent } from "./organization/components/organization-update.component";
import { OrganizationListComponent } from "./organization/components/organization-list.component";
import { OrganizationContactPopupComponent } from "./organization/components/organization-contact-popup.component";
import { OrganizationAdminListComponent } from "./organizationadmin/components/organizationAdmin-list.component";
import { AddOrganizationAdminPopupComponent } from "./organizationadmin/components/add-organizationadmin-popup.component";
import { OrgAdminComponent } from "./role/components/orgadmin.component";
import { OrgAdminAuthGuard } from "./shared/guard/auth-guard-orgadmin.service";
import { OrganizationDriverComponent } from "./organization/components/organizationdriver-list.component";
import { SnailTrailDriverPopupComponent } from "./snail-trail/components/snail-trail-driver-popup.component";
import { SnailTrailBookingPopupComponent } from "./snail-trail/components/snail-trail-booking-popup.component";
import { SnailTrailVehiclePopupComponent } from "./snail-trail/components/snail-trail-vehicle-popup.component";
import { BookingVehiclePopupComponent } from "./booking/components/booking-vehicle-popup.component";
import { BookingDriverPopupComponent } from "./booking/components/booking-driver-popup.component";
import { BookingRequestAdminPopupComponent } from "./booking/components/booking-request-admin-popup.component";
import { BookingSvgPopupComponent } from "./booking/components/booking-svg-popup.component";
import { CustomerListComponent } from "./customer/components/customer-list.component";
import { CustomerUpdateComponent } from "./customer/components/customer-update.component";
import { RoleListComponent } from "./role-management/components/role-list.component";
import { RoleUpdateComponent } from "./role-management/components/role-update.component";
import { CopyRolePopupComponent } from "./role-management/components/copy-role-popup.component";
import { RoleAvailabilityListComponent } from "./roleavailability/components/roleavailability-list.component";
import { RoleAvailabilityPopupComponent } from "./roleavailability/components/roleavailability-update-popup.component";
import { SaveRoleAvailablityPopupComponent } from "./roleavailability/components/save-roleavailability-popup.component";
import { AssignRoleToCustomerComponent } from "./roleavailability/components/assign-role-to-customer-popup.component";
import { AdminOfCustomerListComponent } from "./admin-of-customer/components/admin-of-customer-list.component";
import { AdminOfsharedVehicleGroupListComponent } from "./admin-of-sharedvehiclegroup/components/admin-of-sharedvehiclegroup-list.component";
import { AdminOfInstanceListComponent } from "./admin-of-instance/components/admin-of-instance-list.component";
import { AdminInvitationComponent } from "./admin-invitation/components/admin-invitation.component";
import { AdminInvitationAcceptComponent } from "./admin-invitation/components/admin-invitation-accept.component";
import { AdminInvitationRejectComponent } from "./admin-invitation/components/admin-invitation-reject.component";
import { InviteAdminPopupComponent } from "./admin-invite-popup/components/invite-admin-popup.component";
import { AdminOfCompanyListComponent } from "./admin-of-company/components/admin-of-comapny-list.component";
import { AdminOfOrganizationListComponent } from "./admin-of-organization/components/admin-of-organization-list.component";
import { OrganizationSubscriptionComponent } from "./organizationsubscription/components/organization-subscription-list.component";
import { AssignOrganizationSubscriptionPopupComponent } from "./organizationsubscription/components/organization-subscription-popup.component";
import { OrganizationDriverListComponent } from "./organizationdriver/components/organization-driver-list.component";
import { AssignOrganizationDriverPopupComponent } from "./organizationdriver/components/organization-driver-popup.component";
import { InviteDriverPopupComponent } from "./organizationdriver/components/invite-driver-popup.component";
import { AdminComponent } from "./role/components/admin.component";
import { AuthorizedLinkComponent } from "./shared/components/autorized-link.component";
import { VatSettingsPopupComponent } from "./vat-setting/component/vat-setting-popup.component";
import { VatSettingsComponent } from "./vat-setting/component/vat-setting.component";
import { ReportCustomerFilter } from "./report/components/report-filter-customer.component";
import { HomePageAuthGuard } from "./shared/guard/auth-guard-home-page.service";
import { ErrorLogListComponent } from "./errorlog/components/errorlog-list.component";
import { InterfaceStatusListComponent } from "./interfacestatus/components/interfacestatus-list.component";
import { ErrorEscalationComponent } from "./errorescalation-configuration/components/errorescalation-list.component";
import { ErrorEscalationUpdateComponent } from "./errorescalation-configuration/components/errorescalation-update.component";
import { CostAndExpenseListComponent } from "./cost-expenses/components/cost-expenses-list.components";
import { CostAndExpensePersonPopupComponent } from "./cost-expenses/components/costandexpense-person-popup.component";
import { ConfirmCostAndExpenseComponent } from "./cost-expenses/components/confirm-costandexpense-popup.component";
import { InvoiceUpdateComponent } from "./invoice/components/invoice-update.component";
import { InvoiceDriverPopupComponent } from "./invoice/components/invoice-driver-popup.component";
import { InvoiceOrganizationPopupComponent } from "./invoice/components/invoice-organization-popup.component";
import { ManualInvoiceLinePopupComponent } from "./invoice/components/manual-invoice-line.component";
import { TermsAndConditionComponent } from "./termsandcondition/components/terms-condition-list.component";
import { TermsAndConditionAddUpdateComponent } from "./termsandcondition/components/terms-condition-update.component";
import { ViewTermsAndConditionPopupComponent } from "./termsconditionpopup/components/terms-condition-popup.component";
import { TermsAndConditionsPopup } from "./termsconditionpopup/components/terms-and-conditions-popup.component";
import { KickbackComponent } from "./report/components/kickback.component";
import { KickbackDataGridComponent } from "./report/components/kickback-data-grid.component";
import { InvoicingSettingComponent } from "./invoicing-setting/component/invoicing-setting.component";
import { CostAndExpenseListDriverComponent } from "./cost-expenses-driver/components/cost-expenses-driver-list.components";
import { CostAndExpenseDriverPopupComponent } from "./cost-expenses-driver/components/costandexpense-driver-popup.component";
import { ConfirmCostAndExpenseDriverComponent } from "./cost-expenses-driver/components/confirm-costandexpense-driver-popup.component";
import { ManualInvoiceLineUpdatePopupComponent } from "./invoice/components/manual-invoice-line-update.component";
import { CostAddedByAdminPopupComponent } from "./cost-expenses-driver/components/cost-added-by-admin-popup.component";
import { RoundingFormatterService } from "./shared/models/rounding-formatter.service";
import { RoundingFormatterPipe } from "./shared/pipe/rounding-formatter.pipe";
import { SafeHtmlPipe } from "./shared/pipe/safe-html.pipe";
import { InvoicePaymentHistoryListComponent } from "./invoice/components/invoice-payment-history.component";

import { CostCenterReportComponent } from "./report/components/cost-center-report.component";
import { CostCenterReportFilter } from "./report/models/report-filter-cost-center.model";
import { ReportFilterCostCenterComponent } from "./report/components/report-filter-cost-center.component";
import { SelectCostTypePopupComponent } from "./report/components/select-costtype-popup.component";
import { OrganizationDriverListPopupComponent } from "./organizationdriver/components/organization-driver-list-popup.component";
import { SelectVehicleListPopupComponent } from "./vehicle/components/select-vehicle-cost-center-popup.component";
import { SnailTrailDriverBookingPopupComponent } from "./snail-trail-driver/components/snail-trail-driver-booking-popup.component";
import { SnailTrailDriverFilterComponent } from "./snail-trail-driver/components/snail-trail-driver-filter.component";
import { SnailTrailDriverComponent } from "./snail-trail-driver/components/snail-trail-driver.component";
import { PrivacyPopupComponent } from "./privacypopup/component/privacy-popup.component";
import { PrePostTripQuestionComponent } from "./pre-post-trip-question/components/pre-post-trip-question.component";
import { PrePostTripQuestionUpdateComponent } from "./pre-post-trip-question/components/pre-post-trip-question-update.component";
import { PrePostQuestionsOverviewComponent } from "./pre-post-trip-question-overview/components/pre-post-trip-question-overview.components";
import { PrePostQuestionSearchComponent } from "./pre-post-trip-question-overview/components/pre-post-question-search.component";
import { CompanyPopupComponent } from "./termsandcondition/components/terms-condition-company-popup.component";
import { ImageSliderComponent } from "./shared/popup/image-slider-popup.component";
import { CarouselModule } from "ng2-bootstrap/components/carousel";
import { ViewPrivacyStatementPopupComponent } from "./privacypopup/component/privacy-statement-popup.component";
import { TCActivityPopupComponent } from "./termsandcondition/components/tc-activity-log-popup.component";
import { TCActivityLogDriverComponent } from "./termsandcondition/components/tc-activity-log-driver.component";
import { TermsAndConditionsRevokePopup } from "./termsconditionpopup/components/terms-and-conditions-revoke-popup.component";
import { TermsAndConditionsAcceptRejectPopup } from "./termsconditionpopup/components/terms-and-conditions-accept-reject-popup.component";
import { CreditCardPaymentPopupComponent } from "./creditcardpaymentpopup/components/creditcard-payment-popup.component";
import { CreditCardPaymentSuccessComponent } from "./creditcardpaymentpopup/components/creditcard-payment-success.component";
import { CreditCardPaymentFailureComponent } from "./creditcardpaymentpopup/components/creditcard-payment-failure.component";
import { TwoFASelectionPopupComponent } from "./twofa/components/two-fa-selection";
import { TwoFAGoogleSetupPopupComponent } from "./twofa/components/two-fa-google-setup";
import { TwoFAEmailOTPPopupComponent } from "./twofa/components/two-fa-email-otp";
import { TripCommentComponent } from "./tripdatareport/components/tripcomment-popup.component";
//import { TripOverviewDriverComponent } from "./trip-driver/components/trip-overview-driver.component";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    DropdownModule,
    PaginationModule,
    ModalModule,
    AlertModule,
    ProgressbarModule,
    PopoverModule,
    ColorPickerModule,
    CarouselModule
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    NotFoundComponent,
    PrivacyNotAllowComponent,
    UnAuthenticatedComponent,
    UnAuthorizedComponent,
    // Branding Directives
    BrandingComponent,
    // TopBarItemDirective, PrimaryButtonDirective, SecondaryButtonDirective, HyperLinkDirective,
    // CalendarEventDirective, HighLightDirective, ActiveMenuItemDirective,
    FlatPickrDirective,
    TinymceEditorComponent,
    LodderComponent,
    PopupLodderComponent,
    TranslatePipe,
    SafeHtmlPipe,
    ServerErrorMessagePipe,
    ReadMorePipe,
    DecimalFormatterPipe,
    RoundingFormatterPipe,
    NavbarComponent,
    SidebarComponent,
    MenuItem,
    FooterComponent,
    ContentWrapperComponent,
    DriverNavBarComponent,
    DriverFooterComponent,
    SearchListComponent,
    SortListComponent,
    DriverSearchListComponent,
    SearchFilterComponent,
    SuccessPopupComponent,
    ConfirmPopupComponent,
    //GeoLocationPopupComponent,
    BackofficeComponent,
    WegoAdminComponent,
    CAdminComponent,
    GAdminComponent,
    DriverRoleComponent,
    OrgAdminComponent,
    DriverDashboardComponent,
    AdminDashboardComponent,
    AdminDashboardFilterComponent,
    AdminDashboardGridComponent,
    InstanceListComponent,
    InstanceUpdateComponent,
    PersonListComponent,
    PersonUpdateComponent,
    CompanyListComponent,
    CompanyUpdateComponent,
    CompanyContactPopupComponent,
    CompanyAdminListComponent,
    AddCompanyAdminPopupComponent,
    VehicleListComponent,
    VehicleUpdateComponent,
    VtsVehicleUpdateComponent,
    VtsVehicleListComponent,
    VehicleAttributeCategoryListComponent,
    VehicleAttributeCategoryUpdateComponent,
    VehicleFutureBookingListComponent,
    VehicleAttributeListComponent,
    VehicleAttributeUpdateComponent,
    VehicleInformationComponent,
    SpecialPeriodListComponent,
    SpecialPeriodUpdateComponent,
    DriverListComponent,
    AddDriverPopupComponent,
    AssignDriverGroupPopupComponent,
    DriverSVGListComponent,
    DriverSubscriptionListComponent,
    SharedVehicleGroupListComponent,
    SharedVehicleGroupUpdateComponent,
    SharedVehicleGroupAdminListComponent,
    AddSharedVehicleGroupAdminPopupComponent,
    AddGroupVehiclePopupComponent,
    SVGVehicleComponent,
    SVGDriverComponent,
    WegoAdminListComponent,
    AddWegoAdminPopupComponent,
    TemplateListComponent,
    TemplateUpdateComponent,
    SubscriptionListComponent,
    SubscriptionUpdateComponent,
    ContractTypeGroupListComponent,
    ContractTypeGroupUpdateComponent,
    InActiveContractTypeGroupPopupComponent,
    ContractTypeListComponent,
    ContractTypeUpdateComponent,
    ContractTypeHistoryComponent,
    InvoiceLegacyListComponent,
    InvoiceListComponent,
    SpecialBookingComponent,
    SelectVehiclePopupComponent,
    BookingComponent,
    BookingApproveComponent,
    BookingHistoryComponent,
    BookingInformationComponent,
    BookingInformationComponent2,
    BookingInformationComponent3,
    DriverBookingInformationComponent,
    BookingOverviewComponent,
    BookingRequestComponent,
    BookingHistoryComponent,
    ReportDamagePopupComponent,
    TermsAndConditionComponent,
    ConfirmBookingComponent,
    SelectDriverPopupComponent,
    FilterVehicleOverviewComponent,
    SchedularBookingComponent,
    SearchBookingComponent,
    VehicleOverviewComponent,
    ChangePasswordPopupComponent,
    UserProfile,
    InboxComponent,
    InboxListComponent,
    InboxViewComponent,
    InboxDriverListComponent,
    TripHistoryComponent,
    DriverTripInformationComponent,
    // VehicleSVGListComponent, AssignVehicleGroupPopupComponent,

    ChangePasswordComponent,
    ChangePasswordSuccessComponent,
    ForgotPasswordComponent,
    LinkExpiredComponent,
    UnderConstructionComponent,
    PersonProfile,
    PersonProfileFailurComponent,
    PersonProfileSuccessComponent,
    FileSelectDirective,
    GoogleplaceDirective,
    BookingDriverComponent,
    SearchBookingDriverComponent,
    SchedularBookingDriverComponent,
    BookingOverviewDriverComponent,
    FilterVehicleOverviewDriverComponent,
    VehicleOverviewDriverComponent,
    ConfirmBookingDriverComponent,
    PersonProfile,
    PersonProfileFailurComponent,
    PersonProfileSuccessComponent,
    FileSelectDirective,
    DriverProfile,
    ImportPersonCsvComponent,
    SubscriptionaAvailabilityUpdateComponent,
    SubscriptionAvailabilityListComponent,
    AdditionalFreeItemsUpdateComponent,
    SelectDriverSubscriptionPopupComponent,
    AdditionalFreeItemListComponent,
    TripDetailReportComponent,
    DriverLicenceComponent,
    BookingTripDetailpopupComponent,
    BookingExpensePopupComponent,
    ImagePopupComponent,
    EventViewerComponent,
    PrePostTripQuestionComponent,
    VTSTroubleshootComponent,
    VTSHistoryListComponent,
    FreeBookingpopupComponent,
    GeoLocationMapComponent,
    CalanderPopupComponent,
    LanguageHelperComponent,
    LanguageHelperAPIComponent,
    BookingInfoPopupComponent,
    OdometerLogTrailListComponent,
    OdometerLogTrailUpdateComponent,
    SignupFormConfigUpdateComponent,
    SignupFormConfigListComponent,
    SignupListComponent,
    ConfirmSignupPopupComponent,
    SignUpComponent,
    SignupListComponent,
    MissingIBANPopupComponent,
    DirectDebitFileListComponent,
    SignUpComponent,
    SignupListComponent,
    BatchUploadPersonComponent,
    CreateDirectDebitFilePopupComponent,
    DirectdebitCollectionDatePopupComponent,
    AssignToSVGComponent,
    VehicleOccupancy,
    ReportFilter,
    PrePostQuestionSearchComponent,
    MaintenancePlanningReportComponent,
    RevenuepervehicleReportComponent,
    TripDataReportComponent,
    OrganizationUpdateComponent,
    OrganizationListComponent,
    OrganizationContactPopupComponent,
    OrganizationAdminListComponent,
    ErrorLogListComponent,
    ErrorEscalationComponent,
    ErrorEscalationUpdateComponent,
    InterfaceStatusListComponent,
    AddOrganizationAdminPopupComponent,
    OrganizationDriverComponent,
    SnailTrailComponent,
    SnailTrailFilterComponent,
    SnailTrailDriverPopupComponent,
    SnailTrailBookingPopupComponent,
    SnailTrailVehiclePopupComponent,
    SnailTrailMapComponent,
    BookingVehiclePopupComponent,
    BookingDriverPopupComponent,
    BookingSvgPopupComponent,
    CustomerListComponent,
    CustomerUpdateComponent,
    TermsAndConditionAddUpdateComponent,
    ViewTermsAndConditionPopupComponent,
    BookingSvgPopupComponent,
    RoleListComponent,
    RoleUpdateComponent,
    CopyRolePopupComponent,
    RoleAvailabilityListComponent,
    RoleAvailabilityPopupComponent,
    AssignRoleToCustomerComponent,
    SaveRoleAvailablityPopupComponent,
    AdminOfCustomerListComponent,
    AdminOfsharedVehicleGroupListComponent,
    AdminOfInstanceListComponent,
    AdminInvitationComponent,
    AdminInvitationAcceptComponent,
    AdminInvitationRejectComponent,
    InviteAdminPopupComponent,
    AdminOfCompanyListComponent,
    AdminOfOrganizationListComponent,
    OrganizationSubscriptionComponent,
    AssignOrganizationSubscriptionPopupComponent,
    OrganizationDriverListComponent,
    AssignOrganizationDriverPopupComponent,
    InviteDriverPopupComponent,
    AdminComponent,
    AuthorizedLinkComponent,
    VatSettingsPopupComponent,
    VatSettingsComponent,
    CostAndExpenseListComponent,
    CostAndExpensePersonPopupComponent,
    ConfirmCostAndExpenseComponent,
    MissingIBANPopupComponent,
    InvoiceUpdateComponent,
    InvoiceDriverPopupComponent,
    InvoiceOrganizationPopupComponent,
    ManualInvoiceLinePopupComponent,
    AuthorizedLinkComponent,
    VatSettingsPopupComponent,
    VatSettingsComponent,
    KickbackComponent,
    ReportCustomerFilter,
    CostAndExpenseListDriverComponent,
    CostAndExpenseDriverPopupComponent,
    ConfirmCostAndExpenseDriverComponent,
    CostAddedByAdminPopupComponent,
    KickbackDataGridComponent,
    InvoicingSettingComponent,
    ManualInvoiceLineUpdatePopupComponent,
    TermsAndConditionsPopup,
    CostCenterReportComponent,
    ReportFilterCostCenterComponent,
    SelectCostTypePopupComponent,
    OrganizationDriverListPopupComponent,
    SelectVehicleListPopupComponent,
    SnailTrailDriverBookingPopupComponent,
    SnailTrailDriverFilterComponent,
    SnailTrailDriverComponent,
    ManualInvoiceLineUpdatePopupComponent,
    TermsAndConditionsPopup,
    CostCenterReportComponent,
    ReportFilterCostCenterComponent,
    SelectCostTypePopupComponent,
    OrganizationDriverListPopupComponent,
    SelectVehicleListPopupComponent,
    PrivacyPopupComponent,
    InvoicePaymentHistoryListComponent,
    ManualInvoiceLineUpdatePopupComponent,
    TermsAndConditionsPopup,
    CostCenterReportComponent,
    ReportFilterCostCenterComponent,
    SelectCostTypePopupComponent,
    OrganizationDriverListPopupComponent,
    SelectVehicleListPopupComponent,
    PrePostTripQuestionUpdateComponent,
    PrePostQuestionsOverviewComponent,
    CompanyPopupComponent,
    ImageSliderComponent,
    CurrencyFormatterPipe,
    ViewPrivacyStatementPopupComponent,
    BookingRequestAdminPopupComponent,
    TCActivityPopupComponent,
    TCActivityLogDriverComponent,
    TermsAndConditionsRevokePopup,
    TermsAndConditionsAcceptRejectPopup,
    CreditCardPaymentPopupComponent,
    CreditCardPaymentSuccessComponent,
    CreditCardPaymentFailureComponent,
    TwoFASelectionPopupComponent,
    TwoFAGoogleSetupPopupComponent,
    TwoFAEmailOTPPopupComponent,
    TripCommentComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthService,
    AuthGuard,
    AdminAuthGuard,
    HomePageAuthGuard,
    WAdminAuthGuard,
    CAdminAuthGuard,
    GAdminAuthGuard,
    OrgAdminAuthGuard,
    DriverAdminAuthGuard,
    TRANSLATION_PROVIDERS,
    TranslateService,
    DecimalFormatterService,
    RoundingFormatterService
  ]
  // schemas:[
  //   NO_ERRORS_SCHEMA
  // ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.module.ts